export const accent = '#f90000';

export const colors = {
  pink: '#d66d70',
  black: '#000',
  white: '#fff',
};
